import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaDownload } from "react-icons/fa";

function ProjectCards(props) {
  const defaultImgStyle = {
    height: "230px",
    width: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  };

  const isDownload =
    props.title?.toLowerCase().includes("artspark") ||
    props.demoLink?.includes("drive.google");

  return (
    <Card className="project-card-view text-center">
      {" "}
      {/* 👈 Add text-center for center alignment */}
      <Card.Img
        variant="top"
        src={props.imgPath}
        alt="card-img"
        style={props.imgStyle || defaultImgStyle}
      />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <Card.Text style={{ textAlign: "center" }}>
          {" "}
          {/* 👈 Change to center */}
          {props.description}
        </Card.Text>

        {/* Buttons Centered */}
        <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
          {/* GitHub Button */}
          {props.ghLink && (
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>
          )}

          {/* Demo or Download Button */}
          {!props.isBlog && props.demoLink && (
            <Button variant="primary" href={props.demoLink} target="_blank">
              {isDownload ? (
                <>
                  <FaDownload /> &nbsp; Download APK
                </>
              ) : (
                <>
                  <CgWebsite /> &nbsp; Live Demo
                </>
              )}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;
